<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
<div id="header-container">
  <div>
    <h1 id="header-text">Process GM3PD Vehicle Snapshot</h1>
  </div>


</div>

<div class="top-section-container">
  <div class="vehicle-snapshot-container">
    <h2>Vehicle Snapshot</h2>
    <div id="button-container" class="button-container">
      <!--  button for loading the vehicle snapshot -->
      <div>
        <button mat-raised-button color="primary" id="vehicle-snapshot-button" class="get-snapshot-button"
                (click)="getVehicleSnapshot()">
          Get Vehicle Snapshot
        </button>
      </div>
      <app-upload-button class="upload" [apiUrl]="excelService.excelSheetUrl"
                         (eventEmitter)="upload($event)"></app-upload-button>
    </div>
    <p><b>Note:</b> If you want to load new MCM data with the Vehicle Snapshot, the workbook you upload MUST contain a
      sheet for the Vehicle Snapshot AND contain a sheet for the MCM data</p>
  </div>
  <div class="process-snapshot-container">
    <h2>Process Snapshot</h2>
    <div class="portfolio-type-radio-options">
      <mat-label>Portfolio Type:</mat-label>
      <br/>
      <mat-radio-group aria-label="Portfolio Type" [(ngModel)]="selectedPortfolioType">
        <mat-radio-button [value]="businessPlan.toUpperCase()">{{ businessPlan }}</mat-radio-button>
        <mat-radio-button class="radio-options" [value]="tvp">{{ tvp }}</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="revised-load-radio-options">
      <mat-label>Set Rec Id:</mat-label>
      <br/>
      <mat-radio-group aria-label="Select an option" [(ngModel)]="isKeepRecId">
        <mat-radio-button [value]="true">Revised Load(Keep Old Rec ID)</mat-radio-button>
        <mat-radio-button class="radio-options" [value]="false">New Snapshot</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="rec-id-start">
      <mat-form-field appearance="fill">
        <mat-label>RecId Start</mat-label>
        <input matInput
               type="number"
               onKeyPress="if(this.value.length===5) return false;"
               [(ngModel)]="recIdStart">
      </mat-form-field>
      <button mat-raised-button id="process-snapshot-button"
              class="process-snapshot-button"
              color="primary"
              (click)="processSnapshot()">Create Veh Port
      </button>
    </div>
  </div>

  <div class="manage-lookup-tables d-flex flex-column">
    <h2>Manage Lookup Tables</h2>
    <div class="lookup-table-container">
      <mat-selection-list [(ngModel)]="selectedLookupTables">
        <mat-list-option *ngFor="let lookupTable of lookupTableList" [value]="lookupTable">
          {{ lookupTable }}
        </mat-list-option>
      </mat-selection-list>

    </div>
    <div class="button-container">
      <button mat-raised-button id="download-lookup-table-button"
              class="download-lookup-table-button"
              color="primary"
              [disabled]="selectedLookupTables.length === 0"
              (click)="downloadLookupTable()">Download Lookup Tables
      </button>
      <app-upload-button class="upload" [apiUrl]="excelService.excelSheetUrl"
                         (eventEmitter)="uploadLookupTable($event)"></app-upload-button>
    </div>
  </div>
</div>

<div class="export-button-container" *ngIf="showTable">
  <app-export-button id="export-button" class="no-custom-text"
                     [disabled]="tableDataExportRequest === undefined"
                     [excelExportService]="excelService"
                     [worksheetExportRequest]="tableDataExportRequest">
  </app-export-button>
</div>

<!-- Violation Tabs -->
<mat-tab-group mat-stretch-tabs="false" #violationTabGroup *ngIf="hasViolations"
               (selectedTabChange)="violationTabChange($event)"
               [(selectedIndex)]="violationTabIndex">
  <mat-tab label="Multiple Arch Violations" id="multArchTab"
           *ngIf="violations.multArchPerSevenKeyList.length > 0"></mat-tab>
  <mat-tab label="Multiple Eng Ctr Violations" id="multEngCtrTab"
           *ngIf="violations.multEngCtrPerSevenKeyList.length > 0"></mat-tab>
  <mat-tab label="Date Violations" id="dateViolations" *ngIf="violations.dateViolations.length > 0"></mat-tab>
  <mat-tab label="Blank Cell Violations" id="blankCellTab"
           *ngIf="violations.blankCellViolations.length > 0"></mat-tab>
  <mat-tab label="Invalid Planning Markets" id="invalidPlngMktTab"
           *ngIf="violations.invalidPlngMktList.length > 0"></mat-tab>
  <mat-tab label="Invalid Market Divisions" id="invalidMktDivTab"
           *ngIf="violations.invalidMktDivList.length > 0"></mat-tab>
</mat-tab-group>

<!--    Main Option Table-->
<div class="h-100" *ngIf="showTable">
  <div class="gfs-table">
    <ag-grid-angular
      style="height: 100%;"
      class="ag-theme-quartz"
      [rowData]="displayedData"
      [columnDefs]="vehSnapshotColDef"
      [pagination]="true"
      [paginationPageSize]="pageSize"
      [paginationPageSizeSelector]="[20, 50, 100, 200, 2000]"
      [autoSizeStrategy]="autoSizeStrategy"
    />
  </div>
</div>

